import * as Types from '../../../__generated__/types.generated';

import { gql } from '@apollo/client';
import { InitiationItemBgSettingsFragmentDoc, TeleprompterSettingsFragmentDoc, ShowContactSettingsFragmentDoc, ShoppableInteractionOnInitiationItemFragmentDoc, MultipleChoiceInteractionOnInitiationItemFragmentDoc, HotspotInteractionOnInitiationItemFragmentDoc } from './initiation-item-fragment.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreateInitiationItemMutationVariables = Types.Exact<{
  input: Types.CreateInitiationItemInput;
}>;


export type CreateInitiationItemMutation = { __typename?: 'RootMutationType', createInitiationItem?: { __typename?: 'InitiationItemResult', initiationItem?: { __typename: 'InitiationItem', id: string, databaseId: any, title: string, type: Types.InitiationItemType, interactionType: Types.InteractionType, order: number, collectContact: boolean, useTextFallback: boolean, textColor?: string | null, blurEffect?: number | null, bgType: Types.BackgroundType, bgGradientType: Types.GradientType, bgGradientAngle?: number | null, useTeleprompter: boolean, teleprompterScript?: string | null, teleprompterSpeed?: number | null, teleprompterFontSize?: number | null, teleprompterFontColor?: string | null, showContact: boolean, showContactName: boolean, showContactAvatar: boolean, showContactJobTitle: boolean, showCompanySymbol: boolean, showCompanyName: boolean, content?: { __typename?: 'Content', id: string, groupType: Types.ContentGroupType, providerName?: string | null } | null, interactions: Array<{ __typename: 'HotspotInteraction', id: string, type: Types.InteractionType, hotspotInteractionId: string, hotspots: Array<{ __typename?: 'Hotspot', id: string, x: number, y: number, text: string, textColor: string, bgColor: string, alwaysShowText: boolean, destinationType?: Types.NextInteractionType | null, value?: string | null, middleInteraction: { __typename?: 'MiddleInteraction', id: string, type: Types.MiddleInteractionType, question?: string | null, embed?: { __typename?: 'Embed', id: string, linkUrl: string, oembedResult?: any | null, status: Types.EmbedStatus, reason?: Types.EmbedFailureReason | null } | null } }> } | { __typename: 'MultipleChoiceInteraction', id: string, type: Types.InteractionType, multipleChoiceInteractionId: string, question: { __typename?: 'PageQuestion', id: string, title?: string | null, titleColor: string, showTitle: boolean, timing: number, choices: Array<{ __typename?: 'PageChoice', id: string, type?: Types.NextInteractionType | null, hasNext?: boolean | null, text?: string | null, value?: string | null, order: number, middleInteraction: { __typename?: 'MiddleInteraction', id: string, type: Types.MiddleInteractionType, question?: string | null, embed?: { __typename?: 'Embed', id: string, linkUrl: string, oembedResult?: any | null, status: Types.EmbedStatus, reason?: Types.EmbedFailureReason | null } | null }, nextPage?: { __typename?: 'InitiationItem', id: string, title: string, type: Types.InitiationItemType, order: number } | null }> } } | { __typename: 'ShoppableInteraction', id: string, type: Types.InteractionType, count: number, shoppableInteractionId: string, shoppableProducts: Array<{ __typename?: 'ShoppableProduct', id: string, ctaType: Types.ShoppableProductCtaType, customCtaText?: string | null, product: { __typename?: 'Product', id: string, currencyCode: string, onlineStoreUrl: string, sourceType?: string | null, sourceId?: string | null, title: string, images?: Array<{ __typename?: 'ProductImage', id: string, src?: string | null }> | null, variants?: Array<{ __typename?: 'ProductVariant', id: string, originalPrice?: number | null, price?: number | null }> | null } }> }>, question?: { __typename?: 'PageQuestion', id: string, title?: string | null, titleColor: string, showTitle: boolean, timing: number, choices: Array<{ __typename?: 'PageChoice', id: string, type?: Types.NextInteractionType | null, hasNext?: boolean | null, text?: string | null, value?: string | null, order: number, middleInteraction: { __typename?: 'MiddleInteraction', id: string, type: Types.MiddleInteractionType, question?: string | null, embed?: { __typename?: 'Embed', id: string, linkUrl: string, oembedResult?: any | null, status: Types.EmbedStatus, reason?: Types.EmbedFailureReason | null } | null }, nextPage?: { __typename?: 'InitiationItem', id: string, title: string, type: Types.InitiationItemType, order: number } | null }> } | null, colors?: Array<{ __typename?: 'Color', r: number, g: number, b: number, a: number, hex: string }> | null } | null, userErrors?: Array<{ __typename?: 'UserError', field: string, message: string } | null> | null } | null };


export const CreateInitiationItemDocument = gql`
    mutation CreateInitiationItem($input: CreateInitiationItemInput!) {
  createInitiationItem(input: $input) {
    initiationItem {
      id
      databaseId
      title
      type
      interactionType
      order
      collectContact
      useTextFallback
      textColor
      ...InitiationItemBgSettings
      ...TeleprompterSettings
      ...ShowContactSettings
      content {
        id
        groupType
        providerName
      }
      interactions {
        id
        type
        ... on ShoppableInteraction {
          ...ShoppableInteractionOnInitiationItem
        }
        ... on MultipleChoiceInteraction {
          ...MultipleChoiceInteractionOnInitiationItem
        }
        ... on HotspotInteraction {
          ...HotspotInteractionOnInitiationItem
        }
      }
      question {
        id
        title
        titleColor
        showTitle
        timing
        choices {
          id
          type
          hasNext
          text
          value
          order
          middleInteraction {
            id
            type
            question
            embed {
              id
              linkUrl
              oembedResult
              status
              reason
            }
          }
          nextPage {
            id
            title
            type
            order
          }
        }
      }
      __typename
    }
    userErrors {
      field
      message
    }
  }
}
    ${InitiationItemBgSettingsFragmentDoc}
${TeleprompterSettingsFragmentDoc}
${ShowContactSettingsFragmentDoc}
${ShoppableInteractionOnInitiationItemFragmentDoc}
${MultipleChoiceInteractionOnInitiationItemFragmentDoc}
${HotspotInteractionOnInitiationItemFragmentDoc}`;
export type CreateInitiationItemMutationFn = Apollo.MutationFunction<CreateInitiationItemMutation, CreateInitiationItemMutationVariables>;

/**
 * __useCreateInitiationItemMutation__
 *
 * To run a mutation, you first call `useCreateInitiationItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInitiationItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInitiationItemMutation, { data, loading, error }] = useCreateInitiationItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateInitiationItemMutation(baseOptions?: Apollo.MutationHookOptions<CreateInitiationItemMutation, CreateInitiationItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateInitiationItemMutation, CreateInitiationItemMutationVariables>(CreateInitiationItemDocument, options);
      }
export type CreateInitiationItemMutationHookResult = ReturnType<typeof useCreateInitiationItemMutation>;
export type CreateInitiationItemMutationResult = Apollo.MutationResult<CreateInitiationItemMutation>;
export type CreateInitiationItemMutationOptions = Apollo.BaseMutationOptions<CreateInitiationItemMutation, CreateInitiationItemMutationVariables>;